export default __webpack_public_path__ + "static/media/coins.1100a0ca.svg";